// The same ENABLE list the Go engine embeds (backend/pkg/words/words.txt),
// served at /words.txt by the Vite plugin in vite.config.ts.
let dictionary: Promise<Set<string>> | null = null

export function loadWords(): Promise<Set<string>> {
  dictionary ??= fetch('/words.txt')
    .then((res) => {
      if (!res.ok) throw new Error(`word list: HTTP ${res.status}`)
      return res.text()
    })
    .then((text) => new Set(text.split('\n')))
    .catch((err) => {
      dictionary = null
      throw err
    })
  return dictionary
}
